// extracted by mini-css-extract-plugin
module.exports = {"modal-header":"modal-header___1EJ6d","modal-body":"modal-body___2mVLH","button":"button___fT4En","is-warning":"is-warning___28JFh"};